export default "__VITE_ASSET__BBUxtNGT__"